import BiPaiTableModelBase from "./bipai_table_model_base";
import NetMessageDataBiPaiGame from "../../net/bipai_net_msg_data_game";
import { BiPaiGame } from "../../net/proto/bipai_game";

const { ccclass, property } = cc._decorator;


@ccclass
export default class BiPaiTableModel extends BiPaiTableModelBase {
    
    send_more_card_req(){
        let protoData: BiPaiGame.IMoreCardReq = {

        }
        this.sendMsg(NetMessageDataBiPaiGame.MoreCard, protoData)
    }
    
    send_open_card_req(){
        let protoData: BiPaiGame.IOpenCardReq = {

        }
        this.sendMsg(NetMessageDataBiPaiGame.OpenCard, protoData)
    }

    send_discard_req(cards: number[]){
        let protoData: BiPaiGame.IDiscardReq = {
            card: cards,
        }
        this.sendMsg(NetMessageDataBiPaiGame.Discard, protoData)
    }

    send_follow_req(cards: number[]){
        let protoData: BiPaiGame.IFollowReq = {
            card: cards,
        }
        this.sendMsg(NetMessageDataBiPaiGame.Follow, protoData)
    }

    send_system_open_req(){
        let protoData: BiPaiGame.ISysOpenReq = {            
        }
        this.sendMsg(NetMessageDataBiPaiGame.SysOpen, protoData)
    }
}